import { type FC } from "react";
import { Box, Button } from "@mui/material";
import type { DeviceMode } from "../../model/types";

const horizontalAlignToFlex: Record<string, string> = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
};

export interface CoverButtonItem {
  text: string;
  /** contained | outlined | text; "default" из старых обложек читаем как contained. */
  variant?: string;
}

export interface CoverButtonsProps {
  buttons: CoverButtonItem[];
  color: "primary" | "secondary";
  size: "small" | "medium" | "large";
  align: "left" | "center" | "right";
  /** Принимается ради единообразия пропсов слоёв обложки. */
  device: DeviceMode;
  onClick?: () => void;
}

const toMuiVariant = (variant?: string) =>
  variant === "outlined" || variant === "text" ? variant : "contained";

/**
 * Ряд кнопок обложки. В отличие от витрины кнопки никуда не ведут: в
 * предпросмотре клик открывает боковую панель редактирования.
 */
export const CoverButtons: FC<CoverButtonsProps> = ({
  buttons,
  color,
  size,
  align,
  onClick,
}) => {
  return (
    // Контейнер ряда наследует pointerEvents: none от Inner, поэтому пустое
    // место рядом с кнопками открывает выбор фона, а не глотает клик.
    <Box
      sx={{
        display: "flex",
        gap: 1.75,
        flexWrap: "wrap",
        justifyContent: horizontalAlignToFlex[align] || "center",
        width: "100%",
      }}
    >
      {buttons.map((button, index) => (
        <Button
          key={index}
          variant={toMuiVariant(button.variant)}
          color={color}
          size={size}
          onClick={onClick}
          sx={{ pointerEvents: "auto" }}
        >
          {button.text}
        </Button>
      ))}
    </Box>
  );
};
